import { Injectable } from '@angular/core';
import * as localForage from 'localforage';
import * as UserActions from '@app/core/user/store/actions/user.actions';
import { IAppState } from '@app/store';
import {
  AlertCategory,
  AlertCriterion,
  AlertResponse,
  AlertSettings,
  AlertsService,
  ProductsService,
  UsersService
} from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { from as fromPromise, Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class PriceDropService {
  priceDropItems = [];
  constructor(
    private store: Store<IAppState>,
    private usersService: UsersService,
    private alertsService: AlertsService,
    private productsService: ProductsService
  ) {}

  setPriceDropItems() {
    fromPromise(localForage.getItem('priceDropItem')).subscribe(
      res => {
        if (!res) {
          this.usersService.getPriceDrop().subscribe(
            priceDropItem => {
              const newPriceDropped = Object.assign(this.priceDropItems, priceDropItem.data);
              localForage.setItem('priceDropItem', newPriceDropped);
              this.store.dispatch({
                type: UserActions.SET_USER_PRICE_DROP_FOLLOW_ITEMS,
                payload: newPriceDropped
              });
            },
            error => {
              console.log(error);
            }
          );
        } else {
          this.store.dispatch({
            type: UserActions.SET_USER_PRICE_DROP_FOLLOW_ITEMS,
            payload: res
          });
        }
      },
      () => {}
    );
  }

  priceDropFollow(id: string): Observable<HttpResponse<AlertResponse>> {
    const alertCategory: AlertCategory = 'priceDrop';
    const criteria: Array<AlertCriterion> = [];

    const categoryCriterion: AlertCriterion = {
      key: 'idProduct',
      value: [id]
    };
    criteria.push(categoryCriterion);

    const data: AlertSettings = {
      category: alertCategory,
      criteria: criteria
    };
    this.addPriceDropToLocalForage(id);
    return this.alertsService.createAlert(data, 'response');
  }

  priceDropUnFollow(id: string): Observable<HttpResponse<AlertResponse>> {
    // return false; // il faut créer la bonne route pour que cela fonctionne
    this.removePriceDropToLocalForage(id);
    return this.productsService.deletePriceDrop(id);
  }

  addPriceDropToLocalForage(idItem: string) {
    fromPromise(localForage.getItem('priceDropItem')).subscribe(
      res => {
        const newPriceDropItem = Object.keys(res).map(index => {
          return res[index];
        });
        if (newPriceDropItem.indexOf(idItem) === -1) {
          newPriceDropItem.push(String(idItem));
        }
        this.store.dispatch({
          type: UserActions.ADD_USER_PRICE_DROP_FOLLOW_ITEMS,
          payload: newPriceDropItem
        });
        localForage.setItem('priceDropItem', newPriceDropItem);
      },
      () => {}
    );
  }

  removePriceDropToLocalForage(idItem: string) {
    fromPromise(localForage.getItem('priceDropItem')).subscribe(
      res => {
        const newPriceDropItem = Object.keys(res)
          .map(index => {
            return res[index];
          })
          .filter(item => {
            if (item !== idItem) {
              return item;
            }
          });
        this.store.dispatch({
          type: UserActions.REMOVE_USER_PRICE_DROP_FOLLOW_ITEMS,
          payload: newPriceDropItem
        });
        localForage.setItem('priceDropItem', newPriceDropItem);
      },
      () => {}
    );
  }
}
